module.exports = __webpack_public_path__ + "img/ok@2x.a2e5ed9d.png";